import { render, staticRenderFns } from "./TableSubHead.vue?vue&type=template&id=6ae890e8&"
import script from "./TableSubHead.vue?vue&type=script&lang=js&"
export * from "./TableSubHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ae890e8')) {
      api.createRecord('6ae890e8', component.options)
    } else {
      api.reload('6ae890e8', component.options)
    }
    module.hot.accept("./TableSubHead.vue?vue&type=template&id=6ae890e8&", function () {
      api.rerender('6ae890e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/performance-evaluation/TableSubHead.vue"
export default component.exports